module.exports = __webpack_public_path__ + "static/img/warning_reminder.8ceafda6.png";